import { SET_IS_LOADING } from '../constants'

export function isLoading(state = false, action) {
	switch (action.type) {
		case SET_IS_LOADING:
			return action.status
		default:
			return state
	}
}
